/**
 * Collection – Mobile Filter Drawer
 */
(function (W2B) {
  'use strict';

  let filterEscapeBound = false;

  function initCollectionFilters() {
    const sidebar = document.querySelector('[data-collection-sidebar]');
    const backdrop = document.querySelector('[data-collection-filter-backdrop]');
    const openBtn = document.querySelector('[data-collection-filter-open]');
    const closeBtn = document.querySelector('[data-collection-filter-close]');
    if (!sidebar || sidebar.dataset.filtersBound === 'true') return;
    sidebar.dataset.filtersBound = 'true';

    const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;

    const setOpen = (open) => {
      if (isDesktop()) {
        sidebar.classList.remove('is-open');
        backdrop?.setAttribute('hidden', '');
        openBtn?.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('collection-filter-open');
        return;
      }

      sidebar.classList.toggle('is-open', open);
      if (open) {
        backdrop?.removeAttribute('hidden');
        document.body.classList.add('collection-filter-open');
      } else {
        backdrop?.setAttribute('hidden', '');
        document.body.classList.remove('collection-filter-open');
      }
      openBtn?.setAttribute('aria-expanded', String(open));
    };

    openBtn?.addEventListener('click', () => setOpen(true));
    closeBtn?.addEventListener('click', () => setOpen(false));
    backdrop?.addEventListener('click', () => setOpen(false));

    if (!filterEscapeBound) {
      filterEscapeBound = true;
      document.addEventListener('keydown', (event) => {
        const activeSidebar = document.querySelector('[data-collection-sidebar].is-open');
        if (event.key === 'Escape' && activeSidebar) {
          activeSidebar.classList.remove('is-open');
          document.querySelector('[data-collection-filter-backdrop]')?.setAttribute('hidden', '');
          document.body.classList.remove('collection-filter-open');
          document.querySelector('[data-collection-filter-open]')?.setAttribute('aria-expanded', 'false');
        }
      });
    }

    window.addEventListener('resize', () => {
      if (isDesktop()) setOpen(false);
    });

    setOpen(false);
  }

  W2B.initCollectionFilters = initCollectionFilters;
})(window.W2B = window.W2B || {});

/**
 * Collection – Filterwert-Suche innerhalb langer Filtergruppen
 */
(function () {
  'use strict';

  function bindFilterValueSearch() {
    document.querySelectorAll('[data-filter-value-search]').forEach((input) => {
      if (input.dataset.valueSearchBound === 'true') return;
      input.dataset.valueSearchBound = 'true';

      input.addEventListener('input', () => {
        const group = input.closest('[data-collection-filter-group]');
        const query = input.value.trim().toLowerCase();
        group?.querySelectorAll('[data-filter-value-item]').forEach((item) => {
          item.hidden = query !== '' && !item.textContent.toLowerCase().includes(query);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindFilterValueSearch);
  } else {
    bindFilterValueSearch();
  }

  document.addEventListener('shopify:section:load', bindFilterValueSearch);
})();
